import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from './empty-layout.styles';

interface IFailureLayout {
  ctx: string;
  namespace?: string;
  subMessage?: string;
  fieldKey?: string;
}

export const EmptyLayout: FC<IFailureLayout> = ({ ctx, namespace, subMessage, fieldKey }) => {
  const { t } = useTranslation(namespace);

  const baseMessageKey = 'empty-layouts.message';
  const baseSubKey = 'empty-layouts.sub message';

  const messageKey = fieldKey ? `${fieldKey}.${baseMessageKey}` : baseMessageKey;
  const subKey = fieldKey ? `${fieldKey}.${baseSubKey}` : baseSubKey;

  const message = t(messageKey, { context: ctx });
  const sub = t(subMessage ?? subKey, { context: ctx });

  return (
    <Container>
      <span className="smile">:(</span>
      <span className="message">{message}</span>
      <span className="sub-message">{sub}</span>
    </Container>
  );
};
